import React, { useState } from 'react';
import { stringifyAddressObject } from 'components/HGForm/helpers';
import { Auth } from 'aws-amplify';
import HGForm from 'components/HGForm';

const CustomerForm = ({ setNewUser }) => {
    const [errorMessage, setErrorMessage] = useState('');

    const signUp = async (creds) => {
        setErrorMessage(null);
        try {
            const {
                firstName,
                lastName,
                email,
                password,
                address: addressObject,
                phone,
            } = creds;
            const address = stringifyAddressObject(addressObject);
            const newUserCredentials = {
                username: email,
                password,
                attributes: {
                    email,
                    name: firstName,
                    family_name: lastName,
                    phone_number: '+' + phone,
                    'custom:role': 'Customer',
                    address,
                },
            };
            const user = await Auth.signUp(newUserCredentials);
            if (user) setNewUser(user);
        } catch (error) {
            error.message = error.message.replace(
                'PreSignUp failed with error',
                ''
            );
            setErrorMessage(error.message);
        }
    };

    return (
        <HGForm
            fields={{
                firstName: 'First Name',
                lastName: 'Last Name',
                email: 'Email',
                phone: 'Phone',
                password: 'Password',
                confirmPassword: 'Confirm Password',
                address: 'Address',
            }}
            buttonText="create account"
            handleSubmit={signUp}
            errorMessage={errorMessage}
        />
    );
};

export default CustomerForm;
